import type { ClassType } from '@lingoda/graphql';
import { Box, LingodaClassIcon, colorsPalette } from '@lingoda/ui';
import { MultiplyIcon } from '@lingoda/ui/icons/MultiplyIcon';

interface Props {
    type: ClassType;
    amount: number;
    'aria-label': string;
}

export const CreditsTag = ({ amount, type, ...props }: Props) => {
    return (
        <Box
            color={colorsPalette.blackAlpha[70]}
            display="flex"
            alignItems="center"
            gap={0.25}
            {...props}
        >
            <LingodaClassIcon size={16} type={type} />
            <MultiplyIcon sx={{ fontSize: '0.5rem' }} />
            <Box pb={'1px'} fontWeight={600}>
                {amount}
            </Box>
        </Box>
    );
};
